import { Button, Result } from "antd";
import { auth } from "~/lib/firebase";
import { LoaderFunctionArgs, redirect, useRouteError } from "react-router-dom";
import {
  apiClient,
  BuildingDetailsLoaderResult,
} from "~/services/apiClient";

export const BuildingDetailsPageLoader = async ({
  params,
}: LoaderFunctionArgs) => {
  const user = auth.currentUser;
  if (!user) return redirect("/signup");

  const buildingID = params.buildingID || "";
  if (!buildingID) return redirect("/");

  const result = await apiClient.loader<BuildingDetailsLoaderResult>(
    "building-details",
    { id: buildingID }
  );

  if (!result.success || !result.data) {
    console.error("Building details loader failed:", result.error);
    throw new Response(result.error ?? "Failed to load building", {
      status: 500,
    });
  }

  return result.data;
};

export type BuildingDetailsPageLoaderType = BuildingDetailsLoaderResult;

export const BuildingDetailsPageErrorBoundary = () => {
  const error = useRouteError();
  console.error("Building details page error", error);
  return (
    <Result status="500" title="500" subTitle="Sorry, something went wrong.">
      <Button type="primary" href="/">
        Back Home
      </Button>
    </Result>
  );
};
